import { Collapse } from "antd";
import styled from "styled-components";

export const StyledMLCollapse = styled(Collapse)`
    position: relative;
    width: 100%;
    border: none;

    .ant-collapse-expand-icon {
        position: absolute;
        right: 15px;
        top: 10px;
    }

    .ant-collapse-header {
        padding: 0px !important;
    }
`;
